// src/redux/services/SezInfoSlice.js
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  mapSezinfoResponse,
  mapSezinfoRequest,
} from "@/redux/mappers/Export/CreateNewJob/SezInfoMappers";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";  

export const ProductFTAApi = createApi({
  reducerPath: "productFtaApi",
  baseQuery,
  tagTypes: ["productFta"],
  endpoints: (builder) => ({
    // ✅ Fetch by ExportMasterId
    getProductFTAById: builder.query({
      query: ({id ="68f9f3a929531674453c2451"}) => `import/product/fta/${id}`,
      transformResponse: (response) =>{
        return response?.data?.[0] 
    } ,
      providesTags: (result, error, id) => [{ type: "productFta", id }],
    }),

    // ✅ Update SEZ info (PUT)
    createProductFTA: builder.mutation({
      query: ({ id = "68f9f3a929531674453c2451", ...data }) => ({
        url: `import/product/fta/${id}`,
        method: "PUT",
        headers: {
          "X-Request-Id": crypto.randomUUID(),
        },
        body: {fta: data},
      }),
      invalidatesTags: ["productFta"],
    }),
  }),
});

export const {
  useLazyGetProductFTAByIdQuery,
  useCreateProductFTAMutation,
} = ProductFTAApi;


